import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { AmplifyApiService } from 'src/app/core/services/amplify-api.service';
import { RobotPartHealth } from 'src/app/models/qa-models/robot-part-health';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({ providedIn: 'any' })
export class RobotPartHealthService {
  public qa_rtp_api = APIS.ROBOTS;

  constructor(
    private toastrService: NbToastrService,
    private apiService: AmplifyApiService
  ) {}

  public loadRobotPartHealth(robot_id: string): Promise<RobotPartHealth | null> {
    return this.apiService
      .get(this.qa_rtp_api, `/${ENVIRONMENT.apiHkcInsightsName}/insights/qa/robot-part-health/${robot_id}`, {})
      .then((response: any) => {
        if (response && 'part_counters' in response) {
          return { ...response, robot_id: response.robot_id ?? robot_id } as RobotPartHealth;
        }
        this.toastrService.show($localize`No Part Health found for ${robot_id}`, {
          status: 'danger'
        });
        return null;
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, $localize`Fetching Part Health Failed`, {
          status: 'danger'
        });
        return null;
      });
  }

  public updateRobotPartHealth(robot_id: string, body: RobotPartHealth): Promise<RobotPartHealth | null> {
    return this.apiService
      .put(this.qa_rtp_api, `/${ENVIRONMENT.apiHkcInsightsName}/insights/qa/robot-part-health/${robot_id}`, {
        body: this.stripUiOnlyFields(body)
      })
      .then((response: any) => {
        this.toastrService.show(status, $localize`Robot part health updated`, {
          status: 'success'
        });
        return response;
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, $localize`Updating Part Health Failed`, {
          status: 'danger'
        });
        return null;
      });
  }

  private stripUiOnlyFields(partHealth: RobotPartHealth): object {
    const part_counters = (partHealth.part_counters || []).map((counter: any) => {
      const { count_total, ...rest } = counter;
      return rest;
    });
    return { ...partHealth, part_counters };
  }
}
